export default "__VITE_ASSET__CbO82Qdo__"